import './component-quantity-selector.scss';
import { html } from 'lit';
import ComponentBase from './component-base';
import * as bootstrap from 'bootstrap';
class ComponentQuantitySelector extends ComponentBase {

    static get tagName() { return 'component-quantity-selector' }

    constructor(iniQty) {
        super();
        this.buttons = [
            { value: 1 },
            { value: 2 },
            { value: 3 },
            { value: 4 },
            { value: 5 },
            { value: 6 },
            { value: 7 },
            { value: 8 },
            { value: 9 },
            { value: 'C' },
            { value: 0 },
            { value: 'OK' }
        ]
        this.iniQty = iniQty;
        this.ok = false;
    }

    OnClick(value) {
        const qty = this.querySelector('input#quantity');
        if (value == 'OK') {
            this.ok = true;
            this.instance.hide();
            return;
        }

        qty.value += '' + value;
        if (qty.value == 0)
            qty.value = '0';
        if (qty.value.length > 1 && qty.value.charAt(0) == 0)
            qty.value = qty.value.slice(1);
    }

    render() {
        return html`
            <!-- Modal -->
            <div class="modal" id="quantitySelectorModal" tabindex="-1" role="dialog" aria-labelledby="quantitySelectorModalTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-body">
                            <input type="number" readonly .value=${this.iniQty} class="form-control" id="quantity">
                            <div class="quantity-selector">
                            ${this.buttons.map(button => html`
                                <div @click=${() => { this.OnClick(button.value) }}>${button.value}</div>
                            `)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }

    static Show(iniQty = 0) {
        return new Promise((resolve, reject) => {
            const dialog = new this(iniQty);
            document.body.appendChild(dialog);
            setTimeout(() => {
                dialog.instance = new bootstrap.Modal(document.querySelector('#quantitySelectorModal'));
                document.querySelector('#quantitySelectorModal').addEventListener('hidden.bs.modal', () => {
                    dialog.remove();
                    if (dialog.ok) {
                        const qty = parseInt(dialog.querySelector('input#quantity').value);
                        resolve(qty);
                    } else {
                        resolve(0);
                    }
                })
                dialog.instance.show();
            }, 1)
        })
    }

}
ComponentQuantitySelector.Register();
export default ComponentQuantitySelector;